import React from 'react';
import { motion } from 'framer-motion';
export function CostTable() {
  const data = [{
    sin: 'Años consultando especialistas que no unen los puntos'
  }, {
    sin: 'Medicamentos que tratan el síntoma sin resolver el origen'
  }, {
    sin: 'Vida social limitada por fatiga mental e hinchazón'
  }, {
    sin: 'Google con información contradictoria'
  }, {
    sin: 'Otro año creyendo que "es la edad" y que no hay vuelta atrás'
  }];
  return <section className="py-24 bg-brand-dark" data-id="element-72">
      <div className="container mx-auto px-4" data-id="element-73">
        <div className="max-w-4xl mx-auto" data-id="element-74">
          <div className="text-center mb-12" data-id="element-75">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-gold font-[Poppins,_sans-serif]" data-id="element-76">
              ⚖️ ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
            </h2>
          </div>

          <div className="bg-[#0a2a1a] rounded-2xl border border-[#1a4a2e] overflow-hidden mb-16" data-id="element-77">
            {data.map((row, i) => <div key={i} data-id="element-78">
                <div className="border-l-4 border-[#2d6b45] px-5 py-4 bg-[#0d2f1e]" data-id="element-79">
                  <p className="text-sm md:text-base font-[700] text-[#FFFFFF]" data-id="element-80">
                    ❌ {row.sin}
                  </p>
                </div>
              </div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-81">
            <p className="text-2xl font-bold text-white mb-6" data-id="element-82">
              El próximo lunes puede ser diferente.
            </p>
            <p className="text-xl md:text-3xl font-bold text-brand-light italic font-[Poppins,_sans-serif]" data-id="element-83">
              "Tu cerebro no está roto. Solo está esperando el mapa correcto."
              🧠
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}